import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import Instance from 'highcharts'
import DrillDownModule from 'highcharts/modules/drilldown'
import HighCharts from 'highcharts-react-official'
import { GlobalStyle, Root } from './DrillDownColumnsChart.styles'

DrillDownModule(Instance)

/**
 * The DrillDownColumnsChart's component.
 */
const DrillDownColumnsChart = props => {
  const { categories, data, dataLabelFormatter, id, subData, tooltipFormatter } = props
  const theme = useTheme()
  const [options, setOptions] = useState({})
  const chartRef = useRef()

  useEffect(() => {
    chartRef.current.chart.drillUp()
    setOptions({
      accessibility: { enabled: false },
      chart: {
        height: 400,
        type: 'column'
      },
      drilldown: {
        breadcrumbs: {
          position: { align: 'right' }
        },
        series: subData
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            formatter: dataLabelFormatter,
            style: {
              color: theme.palette.brand.black1,
              fontSize: '8px',
              textOutline: 'none'
            }
          }
        }
      },
      series: data,
      title: { text: '' },
      tooltip: { formatter: tooltipFormatter },
      yAxis: {
        title: { text: '' }
      },
      xAxis: { categories, type: 'category' }
    })
  }, [categories, data, dataLabelFormatter, subData, tooltipFormatter])

  return (
    <>
      <GlobalStyle />
      <Root id={id}>
        <HighCharts highcharts={Instance} options={options} ref={chartRef} />
      </Root>
    </>
  )
}

DrillDownColumnsChart.defaultProps = {
  dataLabelFormatter: function () {
    return this.y
  }
}

DrillDownColumnsChart.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.any.isRequired,
  dataLabelFormatter: PropTypes.func,
  id: PropTypes.string.isRequired,
  subData: PropTypes.any.isRequired,
  tooltipFormatter: PropTypes.func
}

export default DrillDownColumnsChart
